export default class BenutzerRegistrierenRequest {
  nachname: string
  vorname: string
  passwort: string
  benutzername: string
  identifier: string
}
